<template>
	<div>
		<el-dialog :title="dialogTitStr" :visible.sync="dialogVisible" width="500px">
			<el-form :rules="rules" ref="ruleForm" :model="formData" label-width="120px">
				<el-form-item label="承运商" prop="partnershipId">
					<el-select v-model="formData.partnershipId" placeholder="请选择承运商" clearable>
						<el-option v-for="item in partnershipOptions" :key="item.partnershipId" :label="item.partnerName" :value="item.partnershipId"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirmBtnFun">保 存</el-button>
				<el-button @click="cancelBtnFun">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			// 弹框类型 add 添加， dispatch 分配
			dialogType: 'add',
			dialogVisible: false,
			formData: {
				partnershipId: undefined
			},
			rules: {
				partnershipId: [{ required: true, message: '请选择', trigger: 'blur' }],
			},
			partnershipOptions: [],
      saveFlag:false
		}
	},
	computed: {
		dialogTitStr () {
			const map = {
				'add': '添加承运商',
				'dispatch': '分配承运商'
			}
			const msgStr = map[this.dialogType] || '提示'
			return msgStr
		}
	},
	methods: {
		// 打开弹框
		opendDialog (dialogType = 'add', otherParams = {}) {
			this.dialogType = dialogType
			this.otherParams = otherParams
			this.dialogVisible = true
			this.formData.partnershipId = undefined
			if (dialogType == 'add') {
				this.getOptions()
				return
			}
			if (dialogType == 'dispatch') {
				this.getHasAddOptions()
				return
			}
		},
		// 获取京东未添加承运商列表
		getOptions () {
			const url = '/autoapp-default-server-recovery/api/business/partnerManagementBond/findJdUnAllocatePartner'
			this.HttpService.post(url).then(res => {
				if (res.statusCode === 200) {
					// console.log('res===', res)
					const resData = res.data || []
					this.partnershipOptions = resData
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
		// 获取京东承运商列表
		getHasAddOptions () {
			const url = '/autoapp-default-server-recovery/api/business/partnerManagementBond/pageJdPartnerShip'
			const params = {
				currPage: 1,
				pageSize: 99999
			}
			this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
					console.log('res===1111', res)
					const resData = res.data || []
					this.partnershipOptions = resData
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
		// 取消弹框
		cancelBtnFun() {
			this.dialogVisible = false
		},
		// 确认
		confirmBtnFun() {
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					// 添加
					if (this.dialogType == 'add') {
						this.confirmAddReqFun()
						return
					}
					// 分配
					if (this.dialogType == 'dispatch') {
						this.confirmDispatch()
						return
					}
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		// 确认添加请求
		confirmAddReqFun () {
      this.saveFlag = true
			const url = '/autoapp-default-server-recovery/api/business/partnerManagementBond/saveJdPartnership'
			const params = {
				partnershipId: this.formData.partnershipId
			}
			this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
					this.$emit('add-success')
					this.$message.success('添加承运商成功')
					this.dialogVisible = false
				} else {
					const msgTip = res.message || '添加承运商失败'
					this.$message.error(msgTip)
				}
        this.saveFlag = false
			})
		},
		// 确认分配
		confirmDispatch () {
      		this.saveFlag = true
			const url = '/autoapp-default-server-recovery/api/business/partnerManagementBond/saveJdPartnerAllocateRegion'
			const itemObj = this.partnershipOptions.find((item) => item.partnershipId == this.formData.partnershipId) || {}
			debugger
			const {
				partnershipId,
				partnerName,
			} = itemObj
			const {
				provinceCode,
				cityCode,
				id
			} = this.otherParams
			const params = {
				provinceCode,
				cityCode,
				partnershipId,
				partnerName,
				id
			}
			this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
					this.$emit('dispatch-success')
					this.$message.success('承运商分配成功')
					this.dialogVisible = false
				} else {
					const msgTip = res.message || '承运商分配失败'
					this.$message.error(msgTip)
				}
        this.saveFlag = false
			})
		}
	},
}
</script>
<style scoped lang="scss">
.dialog-footer {
	padding: 16px;
	box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/COldForNewService/components/CarrierDialog.vue